import curriculumListEn from "./locales/en.json";

export const CURRICULUM_LIST_NS = "curriculumList" as const;

export const CurriculumListPageTranslations = {
  en: {
    [CURRICULUM_LIST_NS]: {
      ...curriculumListEn,
    },
  },
};
